import { render, staticRenderFns } from "./project-two.vue?vue&type=template&id=7a8edf5a&scoped=true&"
import script from "./project-two.vue?vue&type=script&lang=js&"
export * from "./project-two.vue?vue&type=script&lang=js&"
import style0 from "./project-two.vue?vue&type=style&index=0&id=7a8edf5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8edf5a",
  null
  
)

export default component.exports